import { whatsappColors, type MessageData } from './types';

interface ChatMessageProps {
  message: MessageData;
}

const CheckMarks = ({ status }: { status?: string }) => {
  if (status === 'failed') {
    return (
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
        <circle cx="6" cy="6" r="5" stroke="#ff5252" strokeWidth="1.5"/>
        <path d="M4 4l4 4M8 4l-4 4" stroke="#ff5252" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    );
  }
  const color = status === 'read' ? whatsappColors.blue : whatsappColors.textTertiary;
  return (
    <svg width="16" height="11" viewBox="0 0 16 11" fill="none">
      <path d="M11.071.653a.75.75 0 0 1 1.06 0l3.536 3.536a.75.75 0 0 1 0 1.06l-8.132 8.133a.75.75 0 0 1-1.06 0L.653 7.56a.75.75 0 0 1 0-1.06l1.06-1.061a.75.75 0 0 1 1.061 0l4.773 4.773 6.364-6.364a.75.75 0 0 1 1.06 0z" fill={color}/>
      <path d="M5.694.653a.75.75 0 0 1 1.06 0l3.537 3.536a.75.75 0 0 1 0 1.06L2.16 13.382a.75.75 0 0 1-1.06 0L.653 12.935a.75.75 0 0 1 0-1.06L5.694.653z" fill={color}/>
    </svg>
  );
};

export function ChatMessage({ message }: ChatMessageProps) {
  console.log('ChatMessage:', { id: message.id, direction: message.direction, text: message.text?.substring(0, 20) });
  
  if (message.kind === 'separator') {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '8px 0' }}>
        <span
          style={{
            fontSize: '12.5px',
            fontWeight: 500,
            padding: '6px 12px',
            borderRadius: '8px',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            color: whatsappColors.textSecondary,
            boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
          }}
        >
          {message.text}
        </span>
      </div>
    );
  }

  const isOutbound = message.direction === 'outbound';
  const bubbleColor = isOutbound ? '#d9fdd3' : '#ffffff';

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        justifyContent: isOutbound ? 'flex-end' : 'flex-start',
        marginBottom: '2px',
        padding: '0 4px'
      }}
    >
      <div
        style={{
          position: 'relative',
          maxWidth: '75%',
          minWidth: '80px',
          backgroundColor: bubbleColor,
          borderRadius: '8px',
          padding: '6px 8px',
          boxShadow: '0 1px 1px rgba(0,0,0,0.1)'
        }}
      >
        <div
          style={{
            fontSize: '14px',
            lineHeight: '19px',
            color: '#111b21',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap',
            paddingRight: '60px'
          }}
        >
          {message.type === 'text' ? (
            message.text
          ) : (
            <span style={{ fontStyle: 'italic', color: whatsappColors.textSecondary }}>
              📋 Template: {message.templateId ?? ''}
            </span>
          )}
        </div>

        <div
          style={{
            position: 'absolute',
            bottom: '4px',
            right: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            fontSize: '11px',
            color: '#667781'
          }}
        >
          <span>{message.time}</span>
          {isOutbound && message.status && (
            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
              <CheckMarks status={message.status} />
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
